import Vue from "vue";
import "../vue-components/helpers/vue-filters.js";
import "../vue-components/helpers/vue-directives.js";
import "../vue-components/helpers/vue-mixin.js"

import PhoneNumber from 'awesome-phonenumber';
import {isFrench} from "../vue-components/helpers/i18n.js";

export function phoneURL(phone) {
    return PhoneNumber(phone).getNumber(`rfc3966`);
}

Vue.filter(`phoneURL`, phoneURL);

export function phoneNational(phone) {
    return PhoneNumber(phone).getNumber(`national`);
}

Vue.filter(`phoneNational`, phoneNational);

Vue.mixin({
    computed: {
        logoName() {
            return isFrench() ? `logo-fr.png` : `logo-en.png`;
        },
        user() {
            return this.$store.state.user ? this.$store.state.user : null;
        },
        isEmbed() {
            return this.$route.query.hasOwnProperty(`embed`);
        },
        isFromWifi() {
            return this.$route.query.source === `wifi`;
        },
        isAccountActivated() {
            return this.$store.state.user.active;
        },
        contentPaddingClass() {
            return this.isMobileLayout ? `p-3` : `p-4`;
        },
        devMode() {
            return window.env.VUE_APP_ENV === `local` || window.env.VUE_APP_ENV === `dev`;
        }
    },
    methods: {
        isDealerParent() {
            return false;
        },
        printDoc() {
            this.$children[0].print();
        },
        reach(url) {
            if (this.$route.path !== url)
                this.$router.push(url);
        }
    }
});

export default {};
